import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Sanitizer } from '@angular/core';
import { CanLeaveResult, CsPage, NavController } from 'providers/nav-controller';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { uniq } from 'lodash-es';
import { AlertController } from 'providers/alert-controller';
import { FoodDbService } from 'services/food-db.service';
import { LoggingService } from 'services/logging.service';
import { ScheduleTipId, ScheduleTipOccurrence, scheduleTipText } from 'services/coaching-tips.service';
import { LL } from 'i18n/i18n.service';
interface TipHint {
  item: string,
  days: string[]
}

@Component({
    selector: 'page-schedule-tips',
    templateUrl: 'schedule-tips.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ModalPageMarker]
})
export class ScheduleTipsPage extends CsPage<{}> implements OnInit {
  protected LL = LL;

  // App Store 1.4.1: optional scientific-citation help doc per tip
  tips: { tip: string, hints: TipHint[], helpId?: string }[] = []

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public foodDb: FoodDbService,
    protected sanitizer: Sanitizer,
    public logging: LoggingService,
    private cd: ChangeDetectorRef,
  ) {
    super();
  }

  async ionViewCanEnter() {
  }

  async ionViewCanLeave(): Promise<CanLeaveResult<void>> {
    window.localStorage.removeItem('scheduleTipsMessages');
    return true;
  }

  getAllTips() {
    return Object.keys(this.tips);
  }

  async ngOnInit() {
    // written by Home as a ScheduleWarningsData; read with string keys, since an older app version keyed it by sentence
    let tips: Record<string, ScheduleTipOccurrence[]> = JSON.parse(window.localStorage.getItem('scheduleTipsMessages'));
    for (let tip in tips) {
      let daysForUniqueItemList: TipHint[] = [];

      let uniqueItems: string[] = uniq(tips[tip].map((item) => item && item.items.map(e => e.name).join(', ')));
      for (let item of uniqueItems) {
        daysForUniqueItemList.push({ item, days: [] });
        for (let entry of tips[tip]) {
          if (entry.day) {
            if (entry.items.map(e => e.name).join(', ') === item) {
              if (Array.isArray(entry.day)) {
                daysForUniqueItemList[daysForUniqueItemList.length - 1].days.push(entry.day.map(e => e.headerText).join(' - '));
              } else {
                daysForUniqueItemList[daysForUniqueItemList.length - 1].days.push(entry.day.headerText);
              }
            }
          }
        }
      }

      // the warnings are keyed by tip id. If the stored key is not a known id
      // (a blob an older app version wrote, keyed by the tip's sentence), show it as it is
      const isKnownTip = (Object.values(ScheduleTipId) as string[]).includes(tip);
      const tipText = isKnownTip ? scheduleTipText(tip as ScheduleTipId) : tip;
      // App Store 1.4.1: the short-sleep tip links to the sleep/energy citation doc (J1)
      const helpId = tip === ScheduleTipId.ShortSleep ? '@help:references.sleep-activity-tdee' : undefined;
      this.tips.push({ tip: tipText, hints: daysForUniqueItemList, helpId });
    }
    this.cd.markForCheck();
  }

}
